// Do not use this in the <template> tags.
// Use {{myValue | currency}} instead,
// which uses vue-currency-filter behind the scenes.
// This function is meant to be used outside the <template> tags only.
export function simpleCurrencyFilter(n:number):string {
    if (!n) {
        return "R$ 0,00"
    }

    const val = n.toLocaleString('pt-BR', {
        minimumFractionDigits: 2
    })

    return `R$ ${val}`
}
